export const AcceptedRelations = {
  SELF: "self",
  CHILD: "child",
  PARENT: "parent",
  PARENT_IN_LAW: "parent-in-law",
  SIBLING: "sibling",
  SPOUSE: "spouse",
};
